import { Box, Tooltip } from "@chakra-ui/react";
import { TableData } from "../../../components/Table/types";
import { Reconciliation } from "../../../api/types";
import { Update } from "../../../hooks/useEntitySelection";
import { timeToText } from "../../../utils/time";
import { getStatusBadge } from "../../pipelineImports/utils/pipelineImportsTable";
import { IoWarningOutline } from "react-icons/io5";
import { MdOutlineRefresh } from "react-icons/md";

export function reconciliationsTable(data: Reconciliation[], update: Update): TableData {
  // const actionMenu: DialogItem[] = [{ children: "Report", action: (id: EntityId) => update(id, "report") }];

  return data.map((item) => ({
    id: item.id,
    Name: item.name,
    Created: timeToText(item.created_at),
    Status: {
      raw: item.status,
      content: (
        <Box display="flex" alignItems="center" gap="2">
          {getStatusBadge(item.status, item.error as string)}
          {item.status_history?.some((history) => history.status === "reported") && (
            <Tooltip
              label={item.status_history.filter((h) => h.status === "reported").sort((a, b) => b.time - a.time)[0]?.message}
              sx={{
                backgroundColor: "var(--color-background-modal)",
                padding: "var(--m-xxs) var(--m-xs)",
                borderRadius: "var(--border-radius)",
                marginTop: "var(--m-xs)",
                marginRight: "var(--m-xxxl)",
                boxShadow: "0 0 0 1px var(--color-border), 0 5px 15px rgba(0, 0, 0, 0.2)",
                maxWidth: "300px",
                color: "var(--color-text)",
              }}>
              <Box>
                <IoWarningOutline color="var(--color-icon-yellow)" size={20} />
              </Box>
            </Tooltip>
          )}
          {item.status_history?.some((history) => history.status === "rerun") && (
            <Tooltip
              label={item.status_history.filter((h) => h.status === "rerun").sort((a, b) => b.time - a.time)[0]?.message}
              sx={{
                backgroundColor: "var(--color-background-modal)",
                padding: "var(--m-xxs) var(--m-xs)",
                borderRadius: "var(--border-radius)",
                marginTop: "var(--m-xs)",
                marginRight: "var(--m-xxxl)",
                boxShadow: "0 0 0 1px var(--color-border), 0 5px 15px rgba(0, 0, 0, 0.2)",
                maxWidth: "300px",
                color: "var(--color-text)",
              }}>
              <Box>
                <MdOutlineRefresh color="var(--color-icon-blue)" size={20} />
              </Box>
            </Tooltip>
          )}
        </Box>
      ),
    },
    // _actions: {
    //   raw: item.id,
    //   content: <Dialog items={actionMenu.map((e) => ({ ...e, id: item.id }))} />,
    // },
    _drive_file_id: item.drive_file_id ?? "",
  }));
}
